export enum ACTION_TYPES {
  UPDATE_LOAN_DETAILS = 'CM/LOAN_DETAILS/UPDATE_LOAN_DETAILS',
  UPDATE_APPLICANT = 'CM/LOAN_DETAILS/UPDATE_APPLICANT',
  UPDATE_LIFE_ASSURANCE = 'CM/LOAN_DETAILS/UPDATE_LIFE_ASSURANCE',
  UPDATE_PROPERTY = 'CM/LOAN_DETAILS/UPDATE_PROPERTY',
  UPDATE_ADMIN = 'CM/LOAN_DETAILS/UPDATE_ADMIN',
  UPDATE_RATIONALE = 'CM/RATIONALE/UPDATE_RATIONALE',
  UPDATE_REPAYMENT_STRATEGY = 'CM/LOAN_DETAILS/UPDATE_REPAYMENT_STRATEGY',
}
